import React, { useEffect, useState } from "react";
import "./Portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import artGalerie from "../../img/artGalerie.jpeg";
import emmausConnect from "../../img/emmausConnect.jpeg";
import cvFictif from "../../img/cvFictif.png";
import QuizzProject from "../../img/QuizzProject.jpeg";
import "swiper/css";
import "swiper/css/pagination";

const projects = [
  {
    image: artGalerie,
    title: "Art Galerie",
    description:
      "Galerie d’art en ligne pour présenter et organiser des œuvres de manière claire et élégante.",
    tech: ["HTML", "CSS", "JavaScript"],
    demo: "#",
    code: "https://github.com/adelemanga",
  },
  {
    image: emmausConnect,
    title: "Emmaüs Connect",
    description:
      "Projet orienté inclusion numérique, avec une interface accessible et un parcours utilisateur simple.",
    tech: ["React", "CSS"],
    demo: "#",
    code: "https://github.com/adelemanga",
  },
  {
    image: QuizzProject,
    title: "Quizz Project",
    description:
      "Application de quiz interactive pour tester des connaissances et afficher les résultats en temps réel.",
    tech: ["JavaScript", "HTML", "CSS"],
    demo: "#",
    code: "https://github.com/adelemanga",
  },
  {
    image: cvFictif,
    title: "CV Fictif",
    description:
      "Maquette de CV web moderne, centrée sur la lisibilité, la structure et le design responsive.",
    tech: ["HTML", "CSS", "Sass"],
    demo: "#",
    code: "https://github.com/adelemanga",
  },
];

function Portfolio() {
  const [slidesPerView, setSlidesPerView] = useState(3);

  useEffect(() => {
    const update = () => {
      const width = window.innerWidth;
      if (width < 640) setSlidesPerView(1);
      else if (width < 1024) setSlidesPerView(2);
      else setSlidesPerView(3);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return (
    <section className="portfolio section" id="Portfolio">
      <div className="container">
        <div className="section-heading">
          <span>Projets récents</span>
          <span className="accent">Portfolio</span>
          <p className="section-copy">
            Une sélection de réalisations qui illustrent mon approche du design,
            du front-end et de l’expérience utilisateur.
          </p>
        </div>

        <Swiper
          modules={[Pagination]}
          spaceBetween={24}
          slidesPerView={slidesPerView}
          grabCursor
          pagination={{ clickable: true }}
          className="portfolio-slider"
        >
          {projects.map((project) => (
            <SwiperSlide key={project.title}>
              <article className="project-card">
                <div className="project-media">
                  <img src={project.image} alt={project.title} />
                </div>
                <div className="project-body">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <div className="project-tech">
                    {project.tech.map((item) => (
                      <span key={item}>{item}</span>
                    ))}
                  </div>
                  <div className="project-actions">
                    <a className="button" href={project.demo}>
                      Voir le projet
                    </a>
                    {project.code ? (
                      <a
                        className="button button-secondary"
                        href={project.code}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Voir le code
                      </a>
                    ) : null}
                  </div>
                </div>
              </article>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default Portfolio;
